import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'accountNumber' })
export class AccountNumberPipe implements PipeTransform {
  transform(value: string): string {
    const stringValue = value?.toString();
    if (stringValue?.length === 7 && stringValue.indexOf('-') === -1) {
      return '0' + stringValue.substr(0, 3) + '-' + stringValue.substr(3);
    }
    if ((stringValue?.length === 8 || stringValue?.length === 9) && stringValue.indexOf('-') === -1) {
      return stringValue.substr(0, 4) + '-' + stringValue.substr(4);
    }
    return stringValue;
  }
}
